/**
 * Removal orders share the same foundation party identity shape as installations.
 * Re-export installation helpers under removal-specific names.
 */

export {
  type InstallationPartyIdentityPayload as RemovalPartyIdentityPayload,
  type InstallationSessionActor as RemovalSessionActor,
  type ResolveInstallationPartyInput as ResolveRemovalPartyInput,
  type ResolvedInstallationPartyContext as ResolvedRemovalPartyContext,
  resolveInstallationPartyContext as resolveRemovalPartyContext,
  buildInstallationPartyIdentityPayload as buildRemovalPartyIdentityPayload,
  installationPartyIdentityFromSavedOrder as removalPartyIdentityFromSavedOrder,
  pickInstallationSessionActor as pickRemovalSessionActor,
} from "./installationPartyIdentity";
